// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBuoYeECw3CHewtg8hRFUsYyLsn8-7aVfk",
  authDomain: "table-checker-backend.firebaseapp.com",
  databaseURL: "https://table-checker-backend-default-rtdb.firebaseio.com",
  projectId: "table-checker-backend",
  storageBucket: "table-checker-backend.firebasestorage.app",
  messagingSenderId: "72986224177",
  appId: "1:72986224177:web:8699b3d2406221b17f1710",
  measurementId: "G-M0RJJJRFL4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Auth with providers
const auth = getAuth(app);

// Create Google provider instance
const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('profile');
googleProvider.addScope('email');

// Create Apple provider instance
const appleProvider = new OAuthProvider('apple.com');
appleProvider.addScope('email');
appleProvider.addScope('name');

// Initialize other Firebase services
const database = getDatabase(app);
const storage = getStorage(app);
const firestore = getFirestore(app);

export { 
  app, 
  analytics, 
  auth, 
  googleProvider,
  appleProvider,
  database, 
  storage, 
  firestore 
};
